import {BRANDS} from "../actionTypes"

const initialState = {
    chats: [],
    contacts: [],
    userProfile: {},
    selectedUser: {},
    brandsChatWithRd: null,
    brandContacts: [],
    // Per-tab contact lists — backend is source of truth, each fetch replaces the list
    inboxContacts:   {data: []},
    sentContacts:    {data: []},
    archiveContacts: {data: []},
    unreadCounts: { inbox: 0, sent: 0, archive: 0 },
    selectedUserBrandChat: {data: []},
    selectedUserBrandChatLoading: false,
    selectedContactDetail: null,
    brandUserProfile: null,
    brandMessageTempletes: null,
    braodcastContactList: null,
    broadcastResponse: null,
    sendMessageResponse: null,
    contactLoadError: null,
    chatLoadError: null,
    activeTab: 'inbox',
    massMessageDetail: null
}

const chatReducer = (state = initialState, action) => {
    switch (action.type) {

        case BRANDS.CHAT_GET_USER_PROFILE_FROM_SERVER:
            return {
                ...state,
                brandUserProfile: action.brandUserProfile
            }

        case BRANDS.CHAT_ADD_CONTACT: {
            const newInbox = [action.chatContact, ...(state.inboxContacts?.data || [])]
            return {
                ...state,
                inboxContacts: {data: newInbox}
            }
        }

        // Backend is source of truth — replace the entire tab list on every fetch
        case BRANDS.CHAT_CONTACTS: {
            const incoming = action.chatContacts?.data || action.chatContacts || []
            const tab = action.tab || 'inbox'
            const incomingUnreadCounts = action.chatContacts?.unread_counts || {
                inbox: action.chatContacts?.inbox_unread,
                sent: 0,
                archive: action.chatContacts?.archive_unread
            }

            const map = new Map()
            ;(incoming || []).forEach(item => {
                const key = item.chat_user || item.user_id
                if (key != null && !map.has(String(key))) {
                    map.set(String(key), item)
                }
            })
            const uniqueList = Array.from(map.values())

            const unreadCounts = incomingUnreadCounts.inbox !== undefined
                ? {
                    inbox: incomingUnreadCounts.inbox ?? state.unreadCounts.inbox,
                    sent: 0,
                    archive: incomingUnreadCounts.archive ?? state.unreadCounts.archive
                }
                : state.unreadCounts

            if (tab === 'sent')    return {...state, sentContacts: {data: uniqueList}, unreadCounts}
            if (tab === 'archive') return {...state, archiveContacts: {data: uniqueList}, unreadCounts}
            return {...state, inboxContacts: {data: uniqueList}, unreadCounts}
        }

        case BRANDS.SET_ACTIVE_CHAT_TAB:
            return {
                ...state,
                activeTab: action.tab
            }

        case BRANDS.ARCHIVE_CONVERSATION: {
            const isTarget = (item) =>
                item.chat_user === action.otherUserId || item.user_id === action.otherUserId

            const itemToArchive =
                (state.inboxContacts?.data || []).find(isTarget) ||
                (state.sentContacts?.data  || []).find(isTarget)

            return {
                ...state,
                inboxContacts:   {data: (state.inboxContacts?.data  || []).filter(i => !isTarget(i))},
                sentContacts:    {data: (state.sentContacts?.data    || []).filter(i => !isTarget(i))},
                archiveContacts: {
                    data: itemToArchive
                        ? [{...itemToArchive, is_archived: 1}, ...(state.archiveContacts?.data || [])]
                        : (state.archiveContacts?.data || [])
                }
            }
        }

        case BRANDS.UNARCHIVE_CONVERSATION: {
            const isTarget = (item) =>
                item.chat_user === action.otherUserId || item.user_id === action.otherUserId

            const itemToUnarchive = (state.archiveContacts?.data || []).find(isTarget)

            return {
                ...state,
                archiveContacts: {data: (state.archiveContacts?.data || []).filter(i => !isTarget(i))},
                inboxContacts: {
                    data: itemToUnarchive
                        ? [{...itemToUnarchive, is_archived: 0}, ...(state.inboxContacts?.data || [])]
                        : (state.inboxContacts?.data || [])
                }
            }
        }

        case BRANDS.CHAT_GET_MESSAGE_TEMPLETES:
            return {
                ...state,
                brandMessageTempletes: action.brandMessageTempletes
            }

        case BRANDS.SELECTED_USER_CHAT: {
            // Update the contact in whichever list contains it
            const updateInList = (list) => (list || []).map(item =>
                item.chat_user === action.selectedUserBrandChat?.user?.chat_user
                    ? {...item, ...action.selectedUserBrandChat.user}
                    : item
            )
            return {
                ...state,
                selectedUserBrandChat: action.selectedUserBrandChat,
                inboxContacts:   {data: updateInList(state.inboxContacts?.data)},
                sentContacts:    {data: updateInList(state.sentContacts?.data)},
                archiveContacts: {data: updateInList(state.archiveContacts?.data)}
            }
        }

        case BRANDS.LOAD_SELECTED_USER_CHAT:
            return {
                ...state,
                selectedUserBrandChatLoading: action.selectedUserBrandChatLoading
            }

        case BRANDS.NEW_MESSAGE:
            state.selectedUserBrandChat.data.push(action.message)
            return {...state}

        case BRANDS.CHAT_SELECTED_CONTACT:
            return {
                ...state,
                selectedContactDetail: action.selectedContactDetail
            }

        case BRANDS.MASS_MESSAGE_DETAIL:
            return {
                ...state,
                massMessageDetail: action.massMessageDetail
            }

        case BRANDS.CHAT_BRAODCAST_CONTACTS:
            return {
                ...state,
                braodcastContactList: action.braodcastContactList
            }

        case 'GET_USER_PROFILE':
            return {
                ...state,
                userProfile: action.userProfile
            }

        case 'GET_CHAT_CONTACTS':
            return {
                ...state,
                chats: action.data.chatsContacts,
                contacts: action.data.contacts
            }

        case 'SELECT_CHAT':
            return {
                ...state,
                selectedUser: action.data
            }

        case 'SEND_MSG': {
            const newMsg = action.data.response.chat
            return {
                ...state,
                selectedUser: {...state.selectedUser, chat: newMsg}
            }
        }

        case 'CHAT_BRAND_WITH_RD':
            return {
                ...state,
                brandsChatWithRd: action.brandsChatWithRd
            }

        case 'CLEAT_BROADCAST_LIST':
            return {
                ...state,
                braodcastContactList: null
            }

        case 'CLEAR_CHAT_ON_LOAD':
            return {
                ...state,
                inboxContacts:   {data: []},
                sentContacts:    {data: []},
                archiveContacts: {data: []}
            }

        case 'CLEAR_CHAT_CONTENT_ON_LOAD':
            return {
                ...state,
                selectedUserBrandChat: {data: []}
            }

        case 'CLEAR_CHAT_CONTACT_ON_LOAD':
            return {
                ...state,
                selectedContactDetail: null
            }

        case 'BROADCAST_SUCCESS_RESPONSE':
            return {
                ...state,
                broadcastResponse: action.payload
            }

        case 'CLEAT_BROADCAST_SUCCESS_RESPONSE':
            return {
                ...state,
                broadcastResponse: null
            }

        case 'SEND_MSG_SUCCESS_RESPONSE':
            return {
                ...state,
                sendMessageResponse: action.payload
            }

        case 'SEND_MSG_NULL_RESPONSE':
            return {
                ...state,
                sendMessageResponse: null
            }

        case 'CLEAR_BRAND_CHAT_COUNT_ON_CLICK': {
            const contact = action.payload
            const clearList = (list) => (list || []).map(item =>
                item.user_id === contact?.user_id || item.chat_user === contact?.chat_user
                    ? {...item, unread_messages: 0}
                    : item
            )
            const updatedInbox = clearList(state.inboxContacts?.data)
            const updatedArchive = clearList(state.archiveContacts?.data)
            return {
                ...state,
                inboxContacts:   {data: updatedInbox},
                sentContacts:    {data: clearList(state.sentContacts?.data)},
                archiveContacts: {data: updatedArchive},
                unreadCounts: {
                    inbox: updatedInbox.reduce((sum, c) => sum + (c.unread_messages || 0), 0),
                    sent: 0,
                    archive: updatedArchive.reduce((sum, c) => sum + (c.unread_messages || 0), 0)
                }
            }
        }

        case 'MARK_BRAND_CONVERSATION_UNREAD': {
            const otherUserId = action.payload || action.otherUserId
            const markList = (list) => (list || []).map(item =>
                item.user_id === otherUserId || item.chat_user === otherUserId || item.chatUser === otherUserId
                    ? {...item, unread_messages: (item.unread_messages || 0) + 1}
                    : item
            )
            const updatedInbox = markList(state.inboxContacts?.data)
            const updatedArchive = markList(state.archiveContacts?.data)
            return {
                ...state,
                inboxContacts:   {data: updatedInbox},
                sentContacts:    {data: markList(state.sentContacts?.data)},
                archiveContacts: {data: updatedArchive},
                unreadCounts: {
                    inbox: updatedInbox.reduce((sum, c) => sum + (c.unread_messages || 0), 0),
                    sent: 0,
                    archive: updatedArchive.reduce((sum, c) => sum + (c.unread_messages || 0), 0)
                }
            }
        }

        case 'BRAND_CONTACT_LOAD_ERROR':
            return {...state, contactLoadError: action.payload}

        case 'BRAND_CONTACT_LOAD_ERROR_RESET':
            return {...state, contactLoadError: null}

        case 'BRAND_CHAT_LOAD_ERROR':
            return {...state, chatLoadError: action.payload}

        case 'BRAND_CHAT_LOAD_ERROR_RESET':
            return {...state, chatLoadError: null}

        case 'SELECTED_CHAT_LOADER_RESET':
            return {...state, selectedUserBrandChatLoading: false}

        default:
            return state
    }
}

export default chatReducer
